// src/components/ia-paca/IaSalaryTable.tsx
//
// Tableau salaires IA en PACA — donnée différenciante forte.
// Source : compilation Hellowork + Glassdoor + Factoriel + JeDha
// + observations terrain Recruteurs.io. Région : -15% vs Paris.

interface SalaryRow {
  metier: string;
  junior: string;
  confirme: string;
  senior: string;
  expert?: string;
  notes?: string;
}

const DATA: SalaryRow[] = [
  {
    metier: 'AI Engineer',
    junior: '45 – 55 k€',
    confirme: '55 – 75 k€',
    senior: '75 – 105 k€',
    expert: '100 – 140 k€',
    notes: 'Demande forte en RAG/agents.',
  },
  {
    metier: 'Machine Learning Engineer',
    junior: '42 – 52 k€',
    confirme: '52 – 72 k€',
    senior: '72 – 100 k€',
    expert: '95 – 130 k€',
    notes: 'Profil rare avec exp. prod MLOps.',
  },
  {
    metier: 'MLOps Engineer',
    junior: '45 – 55 k€',
    confirme: '55 – 78 k€',
    senior: '78 – 110 k€',
    notes: 'Marché tendu, prime à l\'infra GPU.',
  },
  {
    metier: 'Data Scientist',
    junior: '38 – 48 k€',
    confirme: '48 – 65 k€',
    senior: '65 – 90 k€',
    expert: '85 – 120 k€',
    notes: 'Volume important, écart selon stack.',
  },
  {
    metier: 'Data Engineer',
    junior: '40 – 50 k€',
    confirme: '50 – 70 k€',
    senior: '70 – 95 k€',
    notes: 'Indispensable pour alimenter les modèles.',
  },
  {
    metier: 'AI Automation Specialist',
    junior: '38 – 48 k€',
    confirme: '48 – 65 k€',
    senior: '65 – 85 k€',
    notes: 'n8n / Make / Zapier + LLM, croissance forte.',
  },
  {
    metier: 'Prompt Engineer',
    junior: '40 – 50 k€',
    confirme: '50 – 68 k€',
    senior: '68 – 90 k€',
    notes: 'Souvent confondu avec AI Engineer. À cadrer.',
  },
  {
    metier: 'AI Product Manager',
    junior: '50 – 62 k€',
    confirme: '62 – 85 k€',
    senior: '85 – 120 k€',
    notes: 'Mix produit + tech, profils rares.',
  },
  {
    metier: 'Architecte IA',
    junior: '—',
    confirme: '70 – 95 k€',
    senior: '95 – 130 k€',
    expert: '125 – 160 k€',
    notes: 'Sénior obligatoire, vision système.',
  },
  {
    metier: 'Consultant IA',
    junior: '40 – 55 k€',
    confirme: '55 – 80 k€',
    senior: '80 – 120 k€',
    notes: 'Forte variance selon BU/cabinet.',
  },
  {
    metier: 'Agentic AI Engineer',
    junior: '50 – 62 k€',
    confirme: '62 – 90 k€',
    senior: '90 – 130 k€',
    notes: 'Émergent. Premium parce que peu de profils.',
  },
];

export default function IaSalaryTable({
  compact = false,
  showSource = true,
}: {
  compact?: boolean;
  showSource?: boolean;
}) {
  const rows = compact ? DATA.slice(0, 6) : DATA;
  return (
    <div className="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm">
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="border-b border-slate-200 bg-slate-50 text-left text-[11px] font-bold uppercase tracking-wider text-slate-600">
            <tr>
              <th className="px-4 py-3">Métier</th>
              <th className="px-4 py-3">Junior (0-2 ans)</th>
              <th className="px-4 py-3">Confirmé (3-7 ans)</th>
              <th className="px-4 py-3">Senior (8+ ans)</th>
              {!compact && <th className="px-4 py-3">Expert / Lead</th>}
              {!compact && <th className="px-4 py-3">Note</th>}
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {rows.map((r) => (
              <tr key={r.metier} className="hover:bg-slate-50/50">
                <td className="px-4 py-3 font-semibold text-slate-900">{r.metier}</td>
                <td className="px-4 py-3 tabular-nums text-slate-700">{r.junior}</td>
                <td className="px-4 py-3 tabular-nums text-slate-700">{r.confirme}</td>
                <td className="px-4 py-3 tabular-nums text-slate-700">{r.senior}</td>
                {!compact && (
                  <td className="px-4 py-3 tabular-nums text-slate-700">
                    {r.expert ?? '—'}
                  </td>
                )}
                {!compact && (
                  <td className="px-4 py-3 text-xs text-slate-500">{r.notes}</td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {showSource && (
        <div className="border-t border-slate-100 bg-slate-50/50 px-4 py-2.5 text-[11px] text-slate-500">
          <strong>Source :</strong> compilation Recruteurs.io · Hellowork ·
          Glassdoor · Factoriel · JeDha · Indeed · observations terrain
          (mars 2026). Région PACA : ajustement -10 à -20% vs Paris, +5%
          sur Sophia Antipolis (tension forte).
        </div>
      )}
    </div>
  );
}
